// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1kIgp","head":"Table_head__2TH4N","col":"Table_col__A5tA-"};